import { render, staticRenderFns } from "./FetchingPage.vue?vue&type=template&id=77710e13&scoped=true&"
import script from "./FetchingPage.vue?vue&type=script&lang=js&"
export * from "./FetchingPage.vue?vue&type=script&lang=js&"
import style0 from "./FetchingPage.vue?vue&type=style&index=0&id=77710e13&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77710e13",
  null
  
)

export default component.exports